const production = {
	state: {
		eat: {
			list: null,
			page: {
				total: 0
			}
		},
		record: {
			list: null,
			page: {
				total: 0
			}
		},
		rfid: {
			list: null,
			page: {
				total: 0
			}
		},
		species: {
			list: null,
			page: {
				total: 0
			}
		},
		speciesP: {
			list: null,
			page: {
				total: 0
			}
		},
		userT: {
			list: null,
			page: {
				total: 0
			}
		},
		turnover: {
			list: null,
			page: {
				total: 0
			}
		},
		claim1: {
			list: null,
			page: {
				total: 0
			}
		},
		claim2: {
			list: [],
			page: {
				total: 0
			}
		},
		ramp: {
			list: null,
			page: {
				total: 0
			}
		},
		pagesize: 20,
		page: 1
	},
	mutations: {
		eat(state,value)
		{
			state.eat=value;
		},
		record(state,value)
		{
			state.record=value;
		},
		rfid(state,value)
		{
			state.rfid=value;
		},
		species(state,value)
		{
			state.species=value;
		},
		speciesP(state,value)
		{
			state.speciesP=value;
		},
		userT(state,value)
		{
			state.userT=value;
		},
		turnover(state,value)
		{
			state.turnover=value;
		},
		claim1(state,value)
		{
			state.claim1=value;
		},
		claim2(state,value)
		{
			state.claim2=value;
		},
		ramp(state,value)
		{
			state.ramp=value;
		},
		pagesize(state,value)
		{
			state.pagesize=value;
		},
		page(state,value)
		{
			state.page=value;
		}
	},
	actions: {
		
	},
	getters: {
		claimS: state=>{
			let values=state.claim2.list.map(value=>{
				return{
					s_rfid_id: value.soleno,
					id: value.id
				}
			});
			return values;
		}
	}
};
export default {
	namespaced: true,
	production
};
